import Index from '@tunnel-components/@pages/explorer/home/container';

/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/explorer/home/index.ts